// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__ssNml","spinnerBase":"Spinner_spinnerBase__AWhY5","spinnerCircle":"Spinner_spinnerCircle__8cbFx"};